import { Box } from "@chakra-ui/react";
import { GradientHalfHero, type GradientHeroProps } from "components/hero";
import Image, { type StaticImageData } from "next/image";
import React from "react";

type LegacyHeroProps = {
  imageSrc: StaticImageData;
  imageAlt: string;
} & Pick<GradientHeroProps, "variant" | "eyebrow" | "title" | "description">;

/**
 * A hero component set up to support legacy heros where we wanted to bring in some
 * new branding with the GradientHalfHero, and needed to support a single static hero image.
 */
export function LegacyMediaHero({ imageSrc, imageAlt, ...heroProps }: LegacyHeroProps) {
  return (
    <GradientHalfHero
      media={
        <Box borderRadius="big" boxShadow="md" overflow="hidden" maxW="560px">
          <Image priority sizes="100%" src={imageSrc} alt={imageAlt} />
        </Box>
      }
      gap={{ base: "biggest", xl: "huge" }}
      {...heroProps}
    />
  );
}
